import { BsSpeedometer } from "react-icons/bs";

import QrCodeIcon from "@mui/icons-material/QrCode";
import CategoryIcon from "@mui/icons-material/Category";
import { RiCommunityLine } from "react-icons/ri";

import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import GavelIcon from "@mui/icons-material/Gavel";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import Person3RoundedIcon from "@mui/icons-material/Person3Rounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";

import Person4Icon from "@mui/icons-material/Person4";
import PasswordIcon from "@mui/icons-material/Password";
import TagIcon from "@mui/icons-material/Tag";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import MonetizationOnTwoToneIcon from "@mui/icons-material/MonetizationOnTwoTone";
import PsychologySharpIcon from "@mui/icons-material/PsychologySharp";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import QuizIcon from "@mui/icons-material/Quiz";
import HelpIcon from "@mui/icons-material/Help";
import DescriptionIcon from "@mui/icons-material/Description";
import { GiReceiveMoney } from "react-icons/gi";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import Dashboard from "../pages/dashboard/Dashboard";
import CommunityList from "../pages/community/CommunityList";
import ViewDetailsComminity from "../pages/community/view/ViewDetailsComminity";
import AddCommunity from "../pages/community/AddCommunity";
import UserManagement from "../pages/userManagement/UserManagement";
import ViewUserDetails from "../pages/userManagement/ViewUserDetails";
import ChangePassword from "../pages/auth/ChangePassword";
import EditCommunity from "../pages/community/EditCommunity";
import HashTagManagement from "../pages/hashTag/HashTagManagement";
import MeetupsManagement from "../pages/meetupsManagement/MeetupsManagement";
import MeetupsDetails from "../pages/meetupsManagement/view/MeetupsDetails";
import Funds from "../pages/theFunds/Funds";
import ResourceManagement from "../pages/resourceManagement/ResourceManagement";
import AddResource from "../pages/resourceManagement/AddResource";
import EditResource from "../pages/resourceManagement/EditResource";
import ViewResourceDetails from "../pages/resourceManagement/view/ViewResourceDetails";
import FundRequest from "../pages/resourceManagement/view/FundRequest";
import CategoryManagement from "../pages/categoryManagement/CategoryManagement";
import FaqManagement from "../pages/faq/FaqManagement";
import NotificationManagement from "../pages/notification/NotificationManagement";
import CmsManagement from "../pages/cmsManagement/CmsManagement";
import PaymentManagement from "../pages/paymentManagement/PaymentManagement";
import Subscription from "../pages/subscription management/Subscription";
import UpdateSubscription from "../pages/subscription management/UpdateSubscription";
import Chat from "../pages/helpAndSupport/Chat";
import ShareDetails from "../pages/community/view/ShareDetails";
import ReferPostList from "../pages/Refer Post/CommunityList";
import ReferDetail from "../pages/Refer Post/view/ShareDetails";
import SettingManagement from "../pages/setting/setting";
import { PiPercentFill } from "react-icons/pi";


export const sidebar = (role = []) => {
  const allSidebar = [
    {
      id: 101,
      enabled: true,
      name: "Dashboard",
      path: "/dashboard",
      icon: <BsSpeedometer style={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 103,
      enabled: true,
      name: "Community Circles",
      path: "/community-circles",
      icon: <RiCommunityLine sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 103,
      enabled: true,
      name: "Referred Shares",
      path: "/refer_post-circles",
      icon: <RiCommunityLine sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 1030,
      enabled: true,
      name: "Meetups Management",
      path: "/meetups-management",
      icon: <GroupsOutlinedIcon sx={{ fontSize: 25 }} />,
      isChild: null,
    },
    // {
    //     id: 104,
    //     enabled: true,
    //     name: "Category Management",
    //     path: "category",
    //     icon: <QrCodeIcon sx={{ fontSize: 18 }} />,
    //     isChild: [
    //         {
    //             id: 4001,
    //             enabled: true,
    //             name: "Category",
    //             path: "/category-management",
    //             icon: <CategoryIcon sx={{ fontSize: 18 }} />,

    //         },
    //         {
    //             id: 4002,
    //             enabled: true,
    //             name: "Sub Category",
    //             path: "/sub-category",
    //             icon: <BabyChangingStationIcon sx={{ fontSize: 18 }} />,
    //         },
    //     ]
    // },
    {
      id: 105,
      enabled: true,
      name: "User Management",
      path: "/user-management",
      icon: <Person4Icon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 106,
      enabled: true,
      name: "The Fund",
      path: "/fund-management",
      icon: <MonetizationOnTwoToneIcon sx={{ fontSize: 24 }} />,
      isChild: null,
    },

    {
      id: 21030,
      enabled: true,
      name: "% to Fund",
      path: "/setting",
      icon: <PiPercentFill sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 105326,
      enabled: true,
      name: "Category Management",
      path: "/category-management",
      icon: <CategoryRoundedIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },

    {
      id: 1036,
      enabled: true,
      name: "Resources Library",
      path: "/resource-management",
      icon: <PsychologySharpIcon sx={{ fontSize: 24 }} />,
      isChild: null,
    },
    {
      id: 1056,
      enabled: true,
      name: "Hashtags",
      path: "/hash-tag",
      icon: <TagIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 1056,
      enabled: true,
      name: "Content Management",
      path: "/cms-management",
      icon: <DescriptionIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 10956,
      enabled: true,
      name: "Help & Support",
      path: "/help-and-support",
      icon: <QuizIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 1956,
      enabled: true,
      name: "FAQ Management",
      path: "/faq-management",
      icon: <HelpIcon sx={{ fontSize: 22 }} />,
      isChild: null,
    },
    {
      id: 11001,
      enabled: true,
      name: "Notification Management",
      path: "/notification-management",
      icon: <NotificationsNoneRoundedIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 102326,
      enabled: true,
      name: "Subscriptions",
      path: "/subscription",
      icon: <LoyaltyIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
    {
      id: 102326,
      enabled: true,
      name: "Bills and Payments",
      path: "/payment-management",
      icon: <GiReceiveMoney style={{ fontSize: 23 }} />,
      isChild: null,
    },
  
    {
      id: 120,
      enabled: true,
      name: "Change Password",
      path: "/change-password",
      icon: <PasswordIcon sx={{ fontSize: 18 }} />,
      isChild: null,
    },
   
  ].filter((data) => data.enabled);
  return allSidebar;
};

export const routes = (role = []) => {
  const allRoutes = [
    {
      id: 101,
      enabled: true,
      element: <Dashboard />,
      path: "/dashboard",
    },
    //-------------communit-circles-Admin----------------------
    {
      id: 2000,
      enabled: true,
      element: <CommunityList />,
      path: "/community-circles",
    },
    {
      id: 10773,
      enabled: true,
      element: <ReferPostList />,
      path: "/refer_post-circles",
    },

    {
      id: 2001,
      enabled: true,
      element: <AddCommunity />,
      path: "/community-circles/create-community",
    },
    {
      id: 2002,
      enabled: true,
      element: <EditCommunity />,
      path: "/community-circles/update-community/:id",
    },
    {
      id: 2003,
      enabled: true,
      element: <ViewDetailsComminity />,
      path: "/community-circles/view-details/:id",
    },
    {
      id: 2002,
      enabled: true,
      element: <ShareDetails />,
      path: "/community-circles/view-details/post-Details/:id",
    },
    //---------------meetups-Management--------------------
    {
      id: 20030,
      enabled: true,
      element: <MeetupsManagement />,
      path: "/meetups-management",
    },
    {
      id: 20031,
      enabled: true,
      element: <MeetupsDetails />,
      path: "/meetups-management/view-details/:id",
    },
    {
      id: 10773,
      enabled: true,
      element: <ReferPostList />,
      path: "/refer_post-circles",
    },
    {
      id: 2002,
      enabled: true,
      element: <ReferDetail />,
      path: "/refer_post-circles/post-Details/:id",
    },
    //---------------user-Management--------------------
    {
      id: 3000,
      enabled: true,
      element: <UserManagement />,
      path: "/user-management",
    },
    {
      id: 3001,
      enabled: true,
      element: <ViewUserDetails />,
      path: "/user-management/view-details/:id",
    },
    //---------------fund-management--------------------
    {
      id: 41200,
      enabled: true,
      element: <Funds />,
      path: "/fund-management",
    },
    //---------------resource-management--------------------
    {
      id: 41200,
      enabled: true,
      element: <ResourceManagement />,
      path: "/resource-management",
    },
    {
      id: 49000,
      enabled: true,
      element: <AddResource />,
      path: "/resource-management/add",
    },
    {
      id: 49230,
      enabled: true,
      element: <EditResource />,
      path: "/resource-management/edit/:id",
    },
    {
      id: 49030,
      enabled: true,
      element: <ViewResourceDetails />,
      path: "/resource-management/view/:id",
    },
    {
      id: 41245,
      enabled: true,
      element: <FundRequest />,
      path: "/resource-management/fund-request/:id",
    },
    //---------------hash-tags--------------------
    {
      id: 4000,
      enabled: true,
      element: <HashTagManagement />,
      path: "/hash-tag",
    },
    //---------------category-management--------------------
    {
      id: 40032,
      enabled: true,
      element: <CategoryManagement />,
      path: "/category-management",
    },
    //---------------FAQ--------------------
    {
      id: 40987,
      enabled: true,
      element: <FaqManagement />,
      path: "/faq-management",
    },
    //---------------FAQ--------------------
    {
      id: 49087,
      enabled: true,
      element: <Chat />,
      path: "/help-and-support",
    },
    //--------------notification----------------------
    {
      id: 1200,
      enabled: true,
      element: <NotificationManagement />,
      path: "/notification-management",
    },
    //--------------cms----------------------
    {
      id: 900120,
      enabled: true,
      element: <CmsManagement />,
      path: "/cms-management",
    },
    //--------------payment----------------------
    {
      id: 922120,
      enabled: true,
      element: <PaymentManagement />,
      path: "/payment-management",
    },
    //--------------Subscription----------------------
    {
      id: 97620,
      enabled: true,
      element: <Subscription />,
      path: "/subscription",
    },
    {
      id: 99820,
      enabled: true,
      element: <UpdateSubscription />,
      path: "/subscription/update/:plan",
    },
    //---------------change-password--------------------
    {
      id: 2100,
      enabled: true,
      element: <ChangePassword />,
      path: "/change-password",
    },
    {
      id: 21030,
      enabled: true,
      element: <SettingManagement />,
      path: "/setting",
    },
  ].filter((data) => data.enabled);
  return allRoutes;
};
